module.exports = __webpack_public_path__ + "img/143ne.60a3a9f6.svg";